import { ref, watch } from 'vue'
import moment from 'moment'

export default function () {
    const timeList = ref([])
    const timeListEnd = ref([])
    const startTime = ref('12:00')
    const endTime = ref('12:00')
    const timeFormat = ref('AM')
    const timeFormatEnd = ref('AM')
    const showStartTime = ref(false)
    const showEndTime = ref(false)
    const selectTimeFormat = ref(false)
    const selectTimeFormatEnd = ref(false)

    ;(() => {
        _getTimeList()
        _getTimeListEnd()
    })()

    watch(
        [timeFormat, timeFormatEnd],
        ([timeFormat, timeFormatEnd]) => {
            if (timeFormat === 'AM') {
                selectTimeFormat.value = true
            } else {
                selectTimeFormat.value = false
            }
            if (timeFormatEnd === 'AM') {
                selectTimeFormatEnd.value = true
            } else {
                selectTimeFormatEnd.value = false
            }
        },
        { immediate: true }
    )

    function resetSetTimeAndDuration() {
        startTime.value = '12:00'
        timeFormat.value = 'AM'
        endTime.value = '12:00'
        timeFormatEnd.value = 'AM'
        showStartTime.value = false
        showEndTime.value = false
    }
    function calculateDuration() {
        const startHourMinute = startTime.value
        const startAMPM = timeFormat.value
        const endHourMinute = endTime.value
        const endAMPM = timeFormatEnd.value
        const momentStart = moment(startHourMinute + ' ' + startAMPM, 'hh:mm A')

        let momentEnd = moment(endHourMinute + ' ' + endAMPM, 'hh:mm A')
        let minutesDifference = momentEnd.diff(momentStart, 'minutes')

        if ((startAMPM === 'PM' && endAMPM === 'AM') || minutesDifference <= 0) {
            momentEnd = moment(endHourMinute + ' ' + endAMPM, 'hh:mm A').add(1, 'd')
            minutesDifference = momentEnd.diff(momentStart, 'minutes')
        }

        return (minutesDifference / 60).toString()
    }
    function calculateEndTime(duration) {
        const _startTime = `${startTime.value} ${timeFormat.value}`
        const momentStart = moment(_startTime, 'hh:mm A')
        const momentEnd = momentStart.add(duration, 'hours')

        let [_endTime, _endTimeFormat] = momentEnd.format('hh:mm A').split(' ')
        let [hour, min] = _endTime.split(':')

        if (parseInt(min) <= 30 && parseInt(min) !== 0) {
            min = '30'
        } else {
            min = '00'
        }

        _endTime = `${hour}:${min}`
        return [_endTime, _endTimeFormat]
    }
    function changeTimeFormat() {
        timeFormat.value = !selectTimeFormat.value ? 'AM' : 'PM'
        selectTimeFormat.value = !selectTimeFormat.value
    }
    function changeEndTimeFormat() {
        selectTimeFormatEnd.value = !selectTimeFormatEnd.value
        timeFormatEnd.value = selectTimeFormatEnd.value ? 'AM' : 'PM'
    }
    function setTime(time) {
        startTime.value = time
        showStartTime.value = false
    }
    function setEndTime(time) {
        endTime.value = time
        showEndTime.value = false
    }
    function handleShowStartTime() {
        showStartTime.value = !showStartTime.value
    }
    function handleShowEndTime() {
        showEndTime.value = !showEndTime.value
    }
    function _getTimeList() {
        for (let hour = 0; hour <= 12; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const formattedMinute = minute.toString().padStart(2, '0')
                let formattedHour = hour.toString().padStart(2, '0')

                if (formattedHour === '00') formattedHour = '12'
                timeList.value.push(`${formattedHour}:${formattedMinute}`)
            }
        }
    }
    function _getTimeListEnd() {
        for (let hour = 0; hour <= 12; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const formattedMinute = minute.toString().padStart(2, '0')
                let formattedHour = hour.toString().padStart(2, '0')

                if (formattedHour === '00') formattedHour = '12'
                timeListEnd.value.push(`${formattedHour}:${formattedMinute}`)
            }
        }
    }

    return {
        timeList,
        timeListEnd,
        startTime,
        endTime,
        timeFormat,
        timeFormatEnd,
        showStartTime,
        showEndTime,
        selectTimeFormat,
        selectTimeFormatEnd,
        resetSetTimeAndDuration,
        calculateDuration,
        calculateEndTime,
        changeTimeFormat,
        changeEndTimeFormat,
        setTime,
        setEndTime,
        handleShowStartTime,
        handleShowEndTime
    }
}
